import { IconPlus } from "@synthesis/shared-icons";
import { Button } from "@synthesis/shared-ui";

import { SearchBar } from "../../../components/search-bar";
import { usePageStore } from "../reference-document-types-page.lib";

/** Панель действий «Виды работ»: поиск и кнопка добавления (модалка открывается через стор). */
export const WorkTypesToolbar = () => {
  const store = usePageStore()!;

  return (
    <div className="flex items-center justify-between gap-4">
      <SearchBar size="sm" clearable placeholder="Поиск по названию или коду" className="w-80 shrink-0" />
      <Button
        theme="primary"
        size="sm"
        leftIcon={<IconPlus className="size-5" aria-hidden />}
        onClick={() => store.setPopupAction({ type: "add-work-type" })}
      >
        Добавить вид работы
      </Button>
    </div>
  );
};
